import script from "./ProductEditorNotFound.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductEditorNotFound.vue?vue&type=script&setup=true&lang=js"

import "./ProductEditorNotFound.vue?vue&type=style&index=0&id=179d245e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-179d245e"]])

export default __exports__